<template>
  <div class="doctor">
    <div class="first itemWrapper">
      <div class="videoArea">
        <video
          preload="none"
          poster="@/assets/img/about/3.png"
          controls="controls"
          ref="video"
        >
          <source
            src="http://mp42.china.com.cn/video_tide/video/2017/11/7/20171171510018041282_408.mp4"
            type="video/mp4"
          />
          浏览器不支持本视频，您可以选择使用其他终端观看。
        </video>
        <div v-if="playStatus == 1" class="controlBtn">
          <img @click="videoPlay" src="@/assets/img/about/play.png" alt="" />
        </div>
      </div>
    </div>
    <div class="second itemWrapper">
      <img src="@/assets/img/about/1.png" alt />
    </div>
    <!-- <div class="third itemWrapper">
      <img src="@/assets/img/about/2.png" alt />
    </div> -->
    <div class="fourth itemWrapper">
      <img src="@/assets/img/about/4.png" alt />
    </div>
  </div>
</template>

<script>
export default {
  name: 'About',
  data () {
    return {
      playStatus: 1
    }
  },
  mounted () {
    console.log(this.$refs.video.paused)
  },
  methods: {
    videoPlay () {
      this.$refs.video.play()
      this.playStatus = 2
    }
  }
}
</script>

<style lang='stylus' scoped>
@import '~@/assets/styles/varibles.styl'

.doctor
  .itemWrapper
    width 100%
    display flex
    flex-direction row
    justify-content center
    align-items center

    img
      width 1280px

    video
      width 1178px
      height 663px
      margin 0
      padding 0
      border 0
      display inline-block
      object-fit contain
      font-size 100%

  .first
    background #050206
    height 663px

  .second
    background #F8F8F8
    height 1000px

  .third
    background #E9E4DC
    height 1000px

  .fourth
    background #F8F8F8
    height 1000px

.videoArea
  width 100%
  height 100%
  position relative
  display flex
  flex-direction row
  justify-content center
  align-items center

  .controlBtn
    width 100%
    position absolute
    left 0
    top 0
    bottom 50px
    display flex
    flex-direction row
    justify-content center
    align-items center

    img
      width 100px
      margin-top 50px
</style>



// WEBPACK FOOTER //
// src/views/About/About.vue